/** Apollo dedupes identical in-flight queries onto one request, so a signal must opt out or aborting it cancels every other caller's copy too. */
export function abortableQueryContext(signal: AbortSignal) {
  return { fetchOptions: { signal }, queryDeduplication: false };
}
